import axios from "axios";
import store from "../store";

const _headers = {
    "Content-Type": "application/json",
    "Accept": "application/json"
};

export const api = axios.create({
    baseURL: "https://api-melvid.melissaandrade.com.br/api/v1/",
    headers: _headers
});

api.interceptors.request.use(config => {
    if (store && store.state.auth.token) {
        config.headers.Authorization = "Bearer " + store.state.auth.token;
    }

    return config;
});

api.interceptors.response.use(response => response, error => {
    const status = error.response ? error.response.status : null;

    if (status === 401) {
        this.$router.push({ name: "auth" });
        next({ name: "auth"});
    }

    return Promise.reject(error);
});

export default {
    api
};
